import { onBeforeUnmount, ref } from 'vue';

import quizWaitingRoomService from '@/services/quizWaitingRoomService.js';

export default function useQuizWaitingRoomActivity() {
    const waitingRoomActivity = ref(null);
    const loading = ref(false);
    const loadError = ref(false);
    let requestController = null;

    async function loadWaitingRoomActivity(source) {
        requestController?.abort();
        const controller = new AbortController();
        requestController = controller;
        waitingRoomActivity.value = null;
        loadError.value = false;
        loading.value = Boolean(source.attemptId || source.activityId);
        if (!loading.value) return;

        try {
            const activity = await quizWaitingRoomService.getActivity(source, controller.signal);
            if (!controller.signal.aborted) waitingRoomActivity.value = activity;
        } catch {
            if (!controller.signal.aborted) loadError.value = true;
        } finally {
            if (!controller.signal.aborted) loading.value = false;
        }
    }

    onBeforeUnmount(() => requestController?.abort());

    return { waitingRoomActivity, loading, loadError, loadWaitingRoomActivity };
}
